import { GET } from '@/helpers';
import { ForAuthorsResponse, StrapiResponse } from '@/types';

export class ForAuthorsApi {
	private CONTACTS_BACKEND_API: string;
	constructor() {
		this.CONTACTS_BACKEND_API = process.env.NEXT_PUBLIC_API_URL + '/avtoram'!;
	}

	async getPageContent(): Promise<StrapiResponse<ForAuthorsResponse> | { error: string }> {
		return GET(this.CONTACTS_BACKEND_API);
	}
}
